<app-alerts></app-alerts>

<div *ngIf="!loadingCover">
   <!--  <div class="row">
<div class="col-12">
		<h5 class="mainTitle">Настройка канала</h5>
</div>

</div> -->
  <form [formGroup]="form" (ngSubmit)="submit()">
   
<div class="row">

    <div class="col-xs-12 col-lg-6">
        <div>
        <nb-card style="width: 100%;">
            <nb-card-header>
            Обкладинка каналу
        </nb-card-header>

             <nb-card-body>
            <div>
                <p>Розмір 1920 x 410</p>

                <div class="imageCover">
                    <div style="width: 100%; "
                    [style.background]=" imageCoverPreview ? 'url(' + imageCoverPreview +')' : ''"
                    ></div>
                </div>


                <div>
                    <input #coverInput (change)="onChangeImage('cover',$event)" style="display: none;" type="file">
                    <button  size="tiny" type="button"  *ngIf="!imageCoverPreview" (click)="coverInput.click()" status="basic" nbButton>Завантажити обкладинку</button>
                    <button  size="tiny" type="button"  *ngIf="imageCoverPreview"  (click)="imageCoverPreview = ''; deleteCover = true;" status="danger" nbButton>Видалити обкладинку</button>

                </div>

            </div>
             </nb-card-body>

         </nb-card>
        </div>
    </div>

    <div class="col-xs-12 col-lg-3">
        <nb-card>
            <nb-card-header>
            Аватар
        </nb-card-header>

             <nb-card-body>
                <div>
                    <p>Розмір 250 x 250</p>
    
                    <div class="imageCover">
                        <div style="max-width: 100px; border-radius: 100px;  "
                        [style.background]=" imageAvatarPreview ? 'url(' + imageAvatarPreview +')' : ''"
                        ></div>

                    </div>
    
    
                    <div>
                        <input #avatarInput (change)="onChangeImage('avatar',$event)" style="display: none;" type="file">

                        <button  size="tiny"  type="button"  *ngIf="!imageAvatarPreview"  (click)="avatarInput.click()" status="basic" nbButton>Завантажити аватар</button>
                     
                 
                        <button  size="tiny"  type="button" *ngIf="imageAvatarPreview"  (click)="imageAvatarPreview = ''; deleteAvatar = true;" status="danger" nbButton>Видалити аватар</button>
                     
                    </div>
    
                </div>
             </nb-card-body>

         </nb-card>  
    </div>

    <div class="col-xs-12 col-lg-3">
        <nb-card>
            <nb-card-header>
            Мініатюра каналу
        </nb-card-header>

             <nb-card-body>
                <div>
                    <p>Розмір 250 x 140</p>
    
                    <div class="imageCover">
                        <div style="max-width: 150px; border-radius: 10px; "
                        [style.background]=" imageThumbPreview ? 'url(' + imageThumbPreview +')' : ''"

                        ></div>

                    </div>
    
    
                    <div>
                        <input #thumbInput (change)="onChangeImage('thumb',$event)" style="display: none;" type="file">
 
                        <button size="tiny"  type="button"  *ngIf="!imageThumbPreview"  (click)="thumbInput.click()" status="basic" nbButton>Завантажити мініатюру</button>
                        <button  size="tiny"  type="button" *ngIf="imageThumbPreview"  (click)="imageThumbPreview = ''; deleteThumb = true;" status="danger" nbButton>Вилучити мініатюру</button>

                    </div>
    
                </div>
             </nb-card-body>

         </nb-card>
    </div>


</div>


<div class="row">

    <div class="col-xs-12 col-md-6">
        <nb-card>
            <nb-card-header>
            Про канал
        </nb-card-header>

             <nb-card-body>


                <div class="mb-10">
                    <p>Назва каналу*</p>
                    <div>
                        <input [class.errorField]="form.get('title').errors?.required && form.get('title').touched"  formControlName="title" nbInput fullWidth type="text" />
                    </div>
                </div>

 

                <div class="mb-10">
                    <p>Опис</p>
                    <div>
                         <textarea  formControlName="description"  nbInput fullWidth></textarea>

                    </div>
                </div>
                <div class="mb-10">
                    <p>URL каналу*</p>
                    <div class="url-item">
                         <span>livestream.ua/channel/</span>
                          <div>
                            <input (change)="onUrlChange($event.target.value)" (blur)="form.get('url').errors && form.get('url').touched ?showUrlAvailable = false : showUrlAvailable = true" (focus)="showUrlAvailable = false"  [class.errorField]="form.get('url').errors && form.get('url').touched"  formControlName="url" nbInput fullWidth type="text" />
                          </div>
			

                    </div>
 <div *ngIf="form.get('url').value  !== channel.url && showUrlAvailable" class="danger" style="text-align:center; margin-top:7px;">
				<span  class="text-success" *ngIf="urlAvailable">URL вільний</span> <span    class="text-danger"  *ngIf="!urlAvailable">URL зайнятий</span>
			   </div>
                </div>

 
           
             </nb-card-body>

         </nb-card>
    </div>

    <div class="col-xs-12 col-md-3">
        <nb-card>
            <nb-card-header>
            Соціальні мережі
        </nb-card-header>

             <nb-card-body>
                <div class="mb-10">
                    <p>Facebook</p>
                    <div>
                        <input placeholder="https://www.facebook.com/livestream.in.ua/" [class.errorField]="form.get('soc_facebook').errors?.pattern && form.get('soc_facebook').touched"  formControlName="soc_facebook" nbInput fullWidth type="text" />
                    </div>
                </div>
                <div class="mb-10">
                    <p>Instagram</p>
                    <div>
                        <input placeholder="https://www.instagram.com/livestream_kiev/" [class.errorField]="form.get('soc_instagram').errors?.pattern && form.get('soc_instagram').touched"   formControlName="soc_instagram" nbInput fullWidth type="text" />
                    </div>
                </div>
                <div class="mb-10">
                    <p>Twitter</p>
                    <div>
                        <input placeholder="https://twitter.com/livestream.in.ua"  [class.errorField]="form.get('soc_twitter').errors?.pattern && form.get('soc_twitter').touched"   formControlName="soc_twitter" nbInput fullWidth type="text" />
                    </div>
                </div>
               <!-- <div class="mb-10">
                    <p>Вконтакте</p>
                    <div>
                        <input [class.errorField]="form.get('soc_vk').errors?.pattern && form.get('soc_vk').touched"   formControlName="soc_vk" nbInput fullWidth type="text" />
                    </div>
                </div> -->

          
             </nb-card-body>

         </nb-card>  
    </div>

    <div class="col-xs-12 col-md-3">
        <nb-card>
            <nb-card-header>
            Месенджери
        </nb-card-header>

             <nb-card-body>
                <div class="mb-10">
                    <p>Whatsapp</p>
                    <div>
                        <input placeholder="https://wa.me/000000000000" formControlName="msg_whatsapp" nbInput fullWidth type="text" />
                    </div>
                </div>
                <div class="mb-10">
                    <p>Telegram</p>
                    <div>
                        <input placeholder="https://t.me/livestream_ua"  formControlName="msg_telegram" nbInput fullWidth type="text" />
                    </div>
                </div>
                <div class="mb-10">
                    <p>Viber</p>
                    <div>
                        <input placeholder="https://viber.click/000000000000" formControlName="msg_viber" nbInput fullWidth type="text" />
                    </div>
                </div>

             </nb-card-body>

         </nb-card>
    </div>


</div>


<div class="row">

    <div class="col-xs-12 col-md-6">
          <nb-card>
              

             <nb-card-body>
                <div style="display: flex; align-items: center;     width: 100%;" >
                    <p style="    margin-right: 15px;">Сайт</p>
                    <div style="    width: 100%;">
                        <input  formControlName="site" nbInput fullWidth type="text" />
                    </div>
                </div> 

             </nb-card-body>

         </nb-card>
  </div>


</div>


<div *ngIf="channel.url" class="row">

    <div class="col-xs-12 col-md-6">
          <nb-card>
              

             <nb-card-body>
                <div style="display: flex; align-items: center;     width: 100%;" >
                    <p style="    margin-right: 15px;margin-bottom: 0;">Вбудувати канал на свій сайт</p>
                    <div style="   margin-left: auto; margin-bottom: 0;">
                         	<a href="javascript:;" (click)="downloadHtml()" >Завантажити HTML</a>
                    </div>
                </div> 

             </nb-card-body>

         </nb-card>
  </div>


</div>

 <div class="row" style="min-height:80px;">
     <div class="col-12">
<div style="position:fixed; right:20px; bottom:-10px;">
<nb-card>
              

             <nb-card-body>
         <button [disabled]="form.invalid || form.disabled || !urlAvailable " nbButton type="submit" status="success">Зберегти</button>

	<a *ngIf="channel.url" style="margin-left:10px;" target="_blank" [routerLink]="['/channel', channel.url ]">Перейти в канал</a>

   </nb-card-body>

         </nb-card>
 </div>
     </div>
 </div>
</form>
</div>

<div *ngIf="loadingCover">

      <app-skeleton-page  [type]="'channel'" ></app-skeleton-page>

   <!-- <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div> -->
</div>
